import React from 'react';
import { Create, SimpleForm, useTranslate } from 'react-admin';
import { Alert } from '@mui/material';
import { USER_ROLE_TO_INT } from '@/config/constants';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { UserFields } from './UserFields';

const BACK_TO = '/system?tab=users';

interface UserFormValues {
  name: string;
  email: string;
  role: string;
}

const transform = (data: UserFormValues) => ({
  name: data.name,
  email: data.email,
  role: USER_ROLE_TO_INT[data.role] ?? 3,
});

export const UserCreate = () => {
  const t = useTranslate();
  return (
    <Create transform={transform} redirect={BACK_TO} actions={<FormPageTitle mode="create" />}>
      <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} />} defaultValues={{ role: 'User' }}>
        <Alert severity="info" sx={{ width: '100%' }}>{t('screens.users.createInfo')}</Alert>
        <UserFields mode="create" />
      </SimpleForm>
    </Create>
  );
};
